import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Navbar, Container, Nav } from 'react-bootstrap';

function Navigation(props) {
  return (
    <div className="navigation">
      <nav className="navbar navbar-expand navbar-custom">
        <div className="container">
          <Link className="navbar-brand" to="/">
            DMPN
          </Link>

          <div>
          <Navbar expand="lg" className="py-0">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto"> 
                  <Nav.Link href="#search">Search</Nav.Link>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Nav.Link href="#info/instructions">Instructions</Nav.Link>
                  <Nav.Link href="#info/about">About the project</Nav.Link>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Nav.Link href="#info/contacts">Contacts</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default withRouter(Navigation);